import { render } from "./koutu-member-center.vue?vue&type=template&id=a5ff9bc8&ts=true"
import script from "./koutu-member-center.vue?vue&type=script&lang=ts"
export * from "./koutu-member-center.vue?vue&type=script&lang=ts"

import "./koutu-member-center.vue?vue&type=style&index=0&id=a5ff9bc8&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])